<template>
  <div class="skillTopic assessment-mb" :class="{'skillTopicPC':$store.state.innerWidth>768}">
     <div class="siteMap-pc" style="background:none !important;">
        <div class="matches">
           <div class="matchesTitle SemiBold mainColor center">
              {{$t('message.Your Career Matches')}}
           </div>
          
           <div class="o-List row">
             <div class="o-box col-xs-6 col-sm-3" v-for="(occupation, index) in occupationsList">
               <div class="box" @click="goOccupationDetail(occupation)">
                 <div class="o-title Bold">
                   <span  class="fourline-box wrap2">
                    <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(occupation.title)}}</a>
                   </span>
                 </div>
                   <img class="img1 noSelect" v-if="index%3==0" src="../images/deco-19.png" />
                   <img class="img2 noSelect" v-if="index%3==1" src="../images/O green1 copy.png" />
                   <img class="img3 noSelect" v-if="index%3==2" src="../images/Vector Smart Object2.png" />
               </div>
             </div>
             <div class="noResult" v-if="occupationsList.length==0">
                  {{$t('message.NoMatchingResults')}}
              </div>
           </div>
        </div>
       <div class="tryOtherQuiz" style="background:none !important;">
        <div class="btn btn-primary" @click="goSelfAssessment">
          <a href="javascript:;" style="color: inherit">{{$t('message.Try another quiz')}}</a>
        </div>
       </div>
     </div>
     <div class="bgImage">
       <img class="bgImg1 noSelect" src="../images/deco-07.png" />
       <img class="bgImg2 noSelect" src="../images/deco-05.png" />
       <img class="bgImg3 noSelect" src="../images/deco-14.png"  v-if="occupationsList.length>0"/>
       <img class="bgImg4 noSelect" src="../images/deco-12.png" />
       <img class="bgImg5 noSelect" src="../images/deco-31.png" />
     </div>
  </div>
</template>
<script>
import { EventBus } from "@/javascripts/eventBus.js";

export default {
    data() {
        return {
            occupationsList:[],
            totalRows:0,
            scoreType:0,
            showEmailPopUp: false,
        }
    },   
    components: {
    },
    created(){
    },
    methods: {
      init:function(){
        var that = this;
        this.scoreType = this.$store.state.formData.scoreType;
        if(this.$store.state.formData.scoreType==1){
          this.getSkillOccupationList(this.$store.state.formData.scoreData)
        }else if(this.$store.state.formData.scoreType==2){
          this.getInterestOccupationList(this.$store.state.formData.scoreData)
        }else if(this.$store.state.formData.scoreType==3){
          this.getBgdAssessmentList(this.$store.state.formData.scoreData)
        }
      },
      getSkillOccupationList:function(scoreData){
        let Base64 = require('js-base64').Base64;
        var that = this;
        this.api.getSkillOccupationList({
          "scoreData":Base64.encode(JSON.stringify(scoreData))
        }, function(data) {
            // that.totalRows = data.totalRows;
            that.$set(that, "occupationsList", data.result);
            if(that.showEmailPopUp && that.occupationsList.length > 0) {
              EventBus.$emit('formPopup', { title: "", scoreType: that.scoreType, occupationsList: data.result })
            }
        })
      },
      getBgdAssessmentList:function(scoreData){
        var that = this;
        this.api.getBgdAssessmentList(scoreData, function(data) {
            // that.totalRows = data.totalRows;
            that.$set(that, "occupationsList", data.result);
            if(that.showEmailPopUp && that.occupationsList.length > 0) {
              EventBus.$emit('formPopup', { title: "", scoreType: that.scoreType, occupationsList: data.result })
            }
        })
      },
      getInterestOccupationList:function(scoreData){
        let Base64 = require('js-base64').Base64;
        var that = this;
        this.api.getInterestOccupationList({
          "scoreData":Base64.encode(JSON.stringify(scoreData))
        }, function(data) {
            // that.totalRows = data.totalRows;
            that.$set(that, "occupationsList", data.result);
            if(that.showEmailPopUp && that.occupationsList.length > 0) {
              EventBus.$emit('formPopup', { title: "", scoreType: that.scoreType, occupationsList: data.result })
            }
        })
      },
      
      goSelfAssessment:function(){
          this.$router.push({ path: '/selfAssessment/', query:{lang:this.$store.state.language} });
      },
      goOccupationDetail:function(item){
        // this.$router.push({path:'/occupationDetails/' + item.id, query:{lang:this.$store.state.language}})

        let routeData = this.$router.resolve({path:'/occupationDetails/' + item.id, query:{lang:this.$store.state.language}});
        window.open(routeData.href, '_blank');
      },
      getQuizSwitch:function() {
        var that = this;
        return new Promise((resolve,reject) => {
          that.api.getQuizSwitch({}, function(data) {
            that.showEmailPopUp = data.result;
            resolve();
          })
        })
      }
    },
    async mounted() {
      this.$store.state.mate.title = this.$i18n.t("message.Self-Assessment")+" - talent.gov.hk"
      await this.getQuizSwitch();
      this.init()
    }
}
</script>